import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import { validateFields } from '../../../utility/validation';
import http, { TOKEN_TYPE, TWO_FACTOR_AUTH } from '../../../utility/http';
import {
  API_2FA_DEACTIVATE,
  API_2FA_INITIATE,
} from '../../../constants/apiRoutes';
import fields from './fields';
import DisableAuthenticationFormLayout from './layout';
import StorageService from '../../../utility/storageService';

const DisableAuthenticationForm = withFormik({
  mapPropsToValues: () => ({ code: '' }),
  validate: async values => {
    throw await validateFields(fields, values);
  },
  enableReinitialize: true,
  validateOnBlur: false,
  handleSubmit: async (values, { props, setErrors, setSubmitting }) => {
    const twoFactorAuth = JSON.parse(StorageService.get(TWO_FACTOR_AUTH));
    http.defaults.headers.Authorization = `${TOKEN_TYPE} ${twoFactorAuth?.accessToken}`;
    try {
      await http
        .post(API_2FA_DEACTIVATE, { code: values.code })
        .then(({ data }) => {
          const is2FARequired =
            !data.has_2fa_enabled &&
            props.organizationSettings?.is_2fa_required;
          if (!is2FARequired) {
            StorageService.remove(TWO_FACTOR_AUTH);
            props.navigate('/');
          } else {
            props.setAuthInfo({
              ...props.auth,
              has_2fa_enabled: data.has_2fa_enabled,
            });

            setSubmitting(false);

            http.post(API_2FA_INITIATE).then(() => {
              setSubmitting(false);
              StorageService.remove(TWO_FACTOR_AUTH);
              props.navigate('/');
            });
          }
        });
    } catch ({ response }) {
      const status = response?.status;
      if (status === 429) {
        setErrors({ error: 'rateLimit' });
      } else {
        setErrors({ error: 'invalid' });
      }
    } finally {
      setSubmitting(false);
    }
  },
})(DisableAuthenticationFormLayout);

DisableAuthenticationForm.propTypes = {
  translations: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  setAuthInfo: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  organizationSettings: PropTypes.object.isRequired,
};

export default DisableAuthenticationForm;
